import { ANALYTICS_EVENTS } from '../../events'
import createAnalyticsStatic, { EventProps } from '../createAnalyticsEvent'

/**
 * Props for InstallAppClicked event.
 */
export type InstallAppClickedProps = EventProps

/**
 * @event PWA Install App Clicked
 */
export const InstallAppClickedAnalytics = createAnalyticsStatic<InstallAppClickedProps>(
    ANALYTICS_EVENTS.PWA.INSTALL_APP_CLICKED,
)

export default InstallAppClickedAnalytics
